import React, { useRef } from 'react';
import { func, string, arrayOf, shape } from 'prop-types';
import { Form as FinalForm, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';
import { intlShape, injectIntl } from '../../util/reactIntl';
import { Button, Form, LocationAutocompleteInput, IconSearch } from '../../components';
import { compose } from 'redux';
import { withViewport } from '../../util/uiHelpers';

import css from './LandingSearchForm.module.css';

const identity = v => v;

const LocationSearchField = props => {
  const { intl, handleChange, isLandingLocation, isSearchPageFilter, locationRef } = props;
  return (
    <Field
      name="location"
      format={identity}
      render={({ input, meta }) => {
        const { onChange, ...restInput } = input;

        const searchOnChange = value => {
          onChange(value);
          handleChange(value);
        };

        const searchInput = { ...restInput, onChange: searchOnChange };
        return (
          <div className={css.locationFld} ref={locationRef}>
            {/* <label htmlFor="searchInput">
              {intl.formatMessage({ id: 'LandingSearchForm.destination' })}
            </label> */}
            <LocationAutocompleteInput
              placeholder={intl.formatMessage({ id: 'LandingSearchForm.location' })}
              iconClassName={css.searchInputIcon}
              inputClassName={css.searchInput}
              predictionsClassName={css.searchPredictions}
              input={searchInput}
              meta={meta}
              rootClassName={isLandingLocation && css.landingLocationSearch}
              isLandingLocation={isLandingLocation}
              isSearchPageFilter={isSearchPageFilter}
              locationRef={locationRef}
            />
          </div>
        );
      }}
    />
  );
};

const LandingSearchFormComponent = props => {
  const locationRef = useRef(null);
  return (
    <FinalForm
      {...props}
      mutators={{ ...arrayMutators }}
      render={formRenderProps => {
        const {
          rootClassName,
          className,
          values,
          intl,
          form,
          isSearchPageFilter,
          isTopbarSearch,
          showTopbarSearch,
        } = formRenderProps;

        const classes = classNames(rootClassName || css.root, className, {
          [css.searchPageFilter]: isSearchPageFilter,
          [css.topbarSearchForm]: isTopbarSearch,
          [css.showTopbarSearch]: showTopbarSearch,
        });

        return (
          <Form className={classes} onSubmit={e => e.preventDefault()}>
            <div className={css.formBody}>
              {/* <span className={css.lineSeparator}></span> */}

              <LocationSearchField
                intl={intl}
                locationRef={locationRef}
                handleChange={location => {
                  if (location.selectedPlace) {
                    form.change('location', location);
                  }
                }}
                isLandingLocation={true}
                isSearchPageFilter={isSearchPageFilter}
                isTopbarSearch={isTopbarSearch}
              />

              <Button
                className={classNames({
                  [css.searchIcon]: isSearchPageFilter,
                  [css.searchBtn]: !isSearchPageFilter,
                })}
                onClick={() => props.onSubmit(values)}
                type="submit"
              >
                {isTopbarSearch ? (
                  <IconSearch />
                ) : (
                  intl.formatMessage({ id: 'LandingSearchForm.search' })
                )}
              </Button>
            </div>
          </Form>
        );
      }}
    />
  );
};

LandingSearchFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  purposeOptions: [],
};

LandingSearchFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  onSubmit: func.isRequired,
  intl: intlShape.isRequired,
  purposeOptions: arrayOf(
    shape({
      option: string.isRequired,
      label: string.isRequired,
    })
  ),
};

const LandingSearchForm = compose(withViewport, injectIntl)(LandingSearchFormComponent);

export default LandingSearchForm;
